var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "k-button k-button-icon chi-audit-button chi-button-attention",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggle_popup($event)
          }
        }
      },
      [
        _c("span", {
          staticClass: "chi-icon-hourglass-end",
          attrs: { role: "presentation" }
        })
      ]
    ),
    _c(
      "div",
      { staticClass: "chi-audit-popup chi-form", attrs: { id: _vm.popup_id } },
      [
        _c(
          "div",
          { staticClass: "chi-form-section" },
          _vm._l(_vm.fields, function(field, index) {
            return _c(
              "div",
              {
                key: field.id,
                staticClass: "chi-form-group",
                style: index % 2 ? { "margin-right": 0 } : { clear: "left" }
              },
              [
                _c("label", {
                  attrs: {
                    for: field.id,
                    title: _vm.components[field.safe_id].hint,
                    role: "label"
                  },
                  domProps: { innerHTML: _vm._s(field.label) }
                }),
                _c("br"),
                _c("input", {
                  ref: field.id,
                  refInFor: true,
                  class: _vm.components[field.safe_id].classes,
                  style: _vm.components[field.safe_id].style,
                  attrs: {
                    id: field.id,
                    title: _vm.components[field.safe_id].hint,
                    readonly: "",
                    role: "readonlyfield",
                    type: "text"
                  },
                  domProps: { value: _vm.components[field.safe_id].value }
                })
              ]
            )
          }),
          0
        ),
        _vm.button
          ? _c(
              "div",
              { staticClass: "chi-audit-button-section" },
              [
                _c(
                  "kendo-button",
                  {
                    ref: _vm.button.id,
                    class: _vm.components[_vm.button.safe_id].classes,
                    style: _vm.components[_vm.button.safe_id].style,
                    attrs: {
                      "data-safe-id": _vm.button.safe_id,
                      "data-send": _vm.components[_vm.button.safe_id].send,
                      id: _vm.button.id,
                      title: _vm.components[_vm.button.safe_id].hint,
                      readonly: "",
                      role: "button"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.on_button_click($event)
                      }
                    }
                  },
                  [
                    !!_vm.components[_vm.button.safe_id].content
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.components[
                                _vm.button.safe_id
                              ].content.replace(/ /g, "&nbsp;")
                            )
                          }
                        })
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }